import React from "react";
import { useNewsletterContext } from "scmp-sdk/components/newsletter/newsletter-widget/contexts";

import { useResponsive } from "shared/hooks";
import { theme } from "shared/lib/styles";
import { notEmpty } from "shared/lib/utils";

import { Container, Divider, ImageContainer, ThumbnailContainer } from "./styles";
import analysisAndOpinionDesktop from "./thumbnail-assets/desktop/analysis-and-opinion.gif";
import biztechAndEconomyDesktop from "./thumbnail-assets/desktop/biztech-and-economy.gif";
import chinaAndAsiaUnpackedDesktop from "./thumbnail-assets/desktop/china-and-asia-unpacked.gif";
import essentialDesktop from "./thumbnail-assets/desktop/essential.gif";
import everythingInHongKongDesktop from "./thumbnail-assets/desktop/everything-in-hong-kong.gif";
import lifestyleDesktop from "./thumbnail-assets/desktop/lifestyle.gif";
import sportDesktop from "./thumbnail-assets/desktop/sport.png";
import videoAndInPictureDesktop from "./thumbnail-assets/desktop/video-and-in-picture.png";
import analysisAndOpinionMobile from "./thumbnail-assets/mobile/analysis-and-opinion.png";
import biztechAndEconomyMobile from "./thumbnail-assets/mobile/biztech-and-economy.png";
import chinaAndAsiaUnpackedMobile from "./thumbnail-assets/mobile/china-and-asia-unpacked.png";
import essentialMobile from "./thumbnail-assets/mobile/essential.png";
import everythingInHongKongMobile from "./thumbnail-assets/mobile/everything-in-hong-kong.png";
import lifestyleMobile from "./thumbnail-assets/mobile/lifestyle.png";
import sportMobile from "./thumbnail-assets/mobile/sport.png";
import videoAndInPictureMobile from "./thumbnail-assets/mobile/video-and-in-picture.png";

const thumbnailMap: Record<string, { desktop: StaticImageData; mobile: StaticImageData }> = {
  "Analysis & Opinion": {
    desktop: analysisAndOpinionDesktop,
    mobile: analysisAndOpinionMobile,
  },
  "BizTech & Economy": {
    desktop: biztechAndEconomyDesktop,
    mobile: biztechAndEconomyMobile,
  },
  "China & Asia unpacked": {
    desktop: chinaAndAsiaUnpackedDesktop,
    mobile: chinaAndAsiaUnpackedMobile,
  },
  Essential: {
    desktop: essentialDesktop,
    mobile: essentialMobile,
  },
  "Everything Hong Kong": {
    desktop: everythingInHongKongDesktop,
    mobile: everythingInHongKongMobile,
  },
  Lifestyle: {
    desktop: lifestyleDesktop,
    mobile: lifestyleMobile,
  },
  "Pictures, Films & Video": {
    desktop: videoAndInPictureDesktop,
    mobile: videoAndInPictureMobile,
  },
  Sport: {
    desktop: sportDesktop,
    mobile: sportMobile,
  },
} as const;

export const ThumbnailDisplay: React.FunctionComponent = () => {
  const { packageDisplayName = "" } = useNewsletterContext();
  const isDesktop = useResponsive(theme.breakpoints.up("tablet"));

  if (!notEmpty(thumbnailMap[packageDisplayName])) return null;

  return (
    <Container>
      <ThumbnailContainer>
        <ImageContainer>
          {isDesktop ? (
            <img alt={packageDisplayName} src={thumbnailMap[packageDisplayName].desktop.src} />
          ) : (
            <img alt={packageDisplayName} src={thumbnailMap[packageDisplayName].mobile.src} />
          )}
        </ImageContainer>
      </ThumbnailContainer>

      <Divider />
    </Container>
  );
};

ThumbnailDisplay.displayName = "ThumbnailDisplay";
